// Client.js
import React from 'react';
import styles from './Client.module.css';
import { Outlet } from 'react-router-dom';

function Client() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default Client;